import { bankDataService } from './services';
import { BankCard, BankItemPage } from './components';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { IModuleConfig } from '../../interfaces';
import { ModuleTypeEnum } from '../../enums';
import {
  AddButton,
  CancelButton,
  DeleteButton,
  EditButton,
  SaveButton,
  ExportButton
} from './components/toolbar-items';
import { UserPermissions } from '../../definitions';

const config: IModuleConfig = {
  id: 'banks',
  name: 'Banks',
  view_permission: UserPermissions.viewUsers,
  edit_permission: UserPermissions.editUsers,
  icon: faUser,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  components: {
    libraryCard: BankCard,
    itemPage: BankItemPage
  },
  services: {
    getByPage: bankDataService.getByPage,
    getSingle: bankDataService.getSingle,
    create: bankDataService.create,
    update: bankDataService.update
  },
  utilities: {
    extractKey: (d: any) => d._id,
    extractItemPath: (d: any) => d._id,
    extractItemBreadcrumb: (d: any) => {
      return d.email_address;
    }
  },
  toolbarItems: {
    library: [AddButton],
    create: [CancelButton, SaveButton],
    edit: [CancelButton, SaveButton],
    view: [AddButton, EditButton, DeleteButton]
  }
};

export default config;
